import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { string } from "prop-types";

import { importScript } from "../../utils/react-utils";

const AdAsia = (props) => {
  const { pageType, lang } = props;

  if (lang === "bn") {
    importScript("//anymind360.com/js/3487/ats.js", pageType);
  }

  return <></>;
};

AdAsia.propTypes = {
  pageType: string,
  lang: string,
};

const mapStateToProps = (state) => ({
  pageType: get(state, ["qt", "pageType"], ""),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
});

export default connect(mapStateToProps)(AdAsia);
